import type { ExerciseAnswerLetter } from "~/features/computer/data/exercises/exercise.types";

export const answerKeys: Record<string, ExerciseAnswerLetter[]> = {
  unit1: ["b", "b", "b", "b", "a", "c", "b"],
  unit2: ["c", "a", "a", "b", "b", "d", "c", "b", "c"],
  unit3: ["c", "d", "b", "a", "d", "c", "c", "c", "b", "c"],
  unit4: ["b", "c", "b", "c", "a", "c"],
  unit5: ["a", "b", "d", "b", "a", "b", "b"],
  unit6: ["b", "c", "c", "b", "b", "b", "d", "b", "a"],
  unit7: ["a", "b", "c", "d", "c", "b", "b", "b", "a"],
  unit8: ["c", "c", "c", "b", "c", "b", "b", "b", "d", "c"],
  unit9: ["b", "b", "c", "b", "b", "b", "b", "b", "b", "b"],
};
